export default __webpack_public_path__ + "static/media/mobile.cd3e862f.svg";